import React, {useEffect} from 'react';
import {useMigrateUserMutation} from "../../../../../redux/apiSlice";
import {Form, Modal} from "react-bootstrap";
import {formToDeepObject} from "../../../../util/Helpers";
import cogoToast from "cogo-toast";

function InitializeMigrationModal({showInitializeMigrationModal, onHide, details, tableRef}) {
    const [
        startMigration, // This is the mutation trigger
        {
            isLoading: isStarting,
            isSuccess: startedSuccessfully,
        }, // This is the destructured mutation result
    ] = useMigrateUserMutation()

    /* Close Modal on Successful Start */
    useEffect(() => {
        if (startedSuccessfully) {
            tableRef.current.refresh();
            cogoToast.success("Migration Successfully Initialized")
            onHide();
        }
    }, [startedSuccessfully, onHide, tableRef]);

    /* Reset Migration */
    const onSubmit = e => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;

        const formData = new FormData(form);

        startMigration(
            {
                userId: details?.user?.unique_id,
                email: details?.email,
                ...formToDeepObject(Object.fromEntries(formData.entries()))
            }
        );
    }

    return (
        <Modal
            show={showInitializeMigrationModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isStarting ? "static" : true}
            keyboard={!isStarting}
        >
            <Form
                noValidate
                onSubmit={onSubmit}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Start Migration
                    </Modal.Title>
                    <button type="button" className="close" onClick={onHide}>
                        <span aria-hidden="true" className="d-block">×</span>
                        <span className="sr-only">Close</span>
                    </button>
                </Modal.Header>

                <Modal.Body style={{maxHeight: "calc(100vh - 300px)", overflow: "auto"}} className={"row"}>
                    {/* <!--begin::Field--> */}
                    {
                        (details?.profileMig < 1) &&
                        <div className={"mb-3 col-6"}>
                            <Form.Check
                                defaultChecked
                                value={true}
                                type={"switch"}
                                name="profileMig"
                                id={"profileMig"}
                                label={"Profile Migration"}
                            />
                        </div>
                    }
                    {/* <!--end::Field--> */}
                    {/* <!--begin::Field--> */}
                    {
                        (details?.kycMig < 1) &&
                        <div className={"mb-3 col-6"}>
                            <Form.Check
                                defaultChecked
                                value={true}
                                type={"switch"}
                                name="kycMig"
                                id={"kycMig"}
                                label={"KYC Migration"}
                            />
                        </div>
                    }
                    {/* <!--end::Field--> */}
                    {/* <!--begin::Field--> */}
                    {
                        (details?.watchlistMig < 1) &&
                        <div className={"mb-3 col-6"}>
                            <Form.Check
                                defaultChecked
                                value={true}
                                type={"switch"}
                                name="watchlistMig"
                                id={"watchlistMig"}
                                label={"Watchlist Migration"}
                            />
                        </div>
                    }
                    {/* <!--end::Field--> */}
                    {/* <!--begin::Field--> */}
                    {
                        (details?.bankMig < 1) &&
                        <div className={"mb-3 col-6"}>
                            <Form.Check
                                defaultChecked
                                value={true}
                                type={"switch"}
                                name="bankMig"
                                id={"bankMig"}
                                label={"Bank Migration"}
                            />
                        </div>
                    }
                    {/* <!--end::Field--> */}
                    {/* <!--begin::Field--> */}
                    {
                        (details?.docsMig < 1) &&
                        <div className={"mb-3 col-6"}>
                            <Form.Check
                                defaultChecked
                                value={true}
                                type={"switch"}
                                name="docsMig"
                                id={"docsMig"}
                                label={"Documents Migration"}
                            />
                        </div>
                    }
                    {/* <!--end::Field--> */}
                    {/* <!--begin::Field--> */}
                    {
                        (details?.paperAccMig < 1) &&
                        <div className={"mb-3 col-6"}>
                            <Form.Check
                                defaultChecked
                                value={true}
                                type={"switch"}
                                name="paperAccMig"
                                id={"paperAccMig"}
                                label={"Paper Account Migration"}
                            />
                        </div>
                    }
                    {/* <!--end::Field--> */}
                    {/* <!--begin::Field--> */}
                    {
                        (details?.usAccMig < 1) &&
                        <div className={"mb-3 col-6"}>
                            <Form.Check
                                defaultChecked
                                value={true}
                                type={"switch"}
                                name="usAccMig"
                                id={"usAccMig"}
                                label={"US Account Migration"}
                            />
                        </div>
                    }
                    {/* <!--end::Field--> */}
                    {/* <!--begin::Field--> */}
                    {
                        (details?.ngAccMig < 1) &&
                        <div className={"mb-3 col-6"}>
                            <Form.Check
                                defaultChecked
                                value={true}
                                type={"switch"}
                                name="ngAccMig"
                                id={"ngAccMig"}
                                label={"NG Account Migration"}
                            />
                        </div>
                    }
                    {/* <!--end::Field--> */}
                </Modal.Body>

                <Modal.Footer>
                    <button
                        type="button"
                        onClick={onHide}
                        disabled={isStarting}
                        className="btn btn-light btn-elevate px-4"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        disabled={isStarting}
                        className="btn btn-primary btn-elevate px-4 ml-4"
                    >
                        Start Migration
                    </button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}

export default InitializeMigrationModal;